import App from './app/App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import { createRoot } from 'react-dom/client';
import './i18n';
import './styles/app-base.css';
import './styles/app-components.css';
import './styles/app-utilities.css';
import { ruRU } from '@mui/material/locale';

if (window.top !== window.self) {
  window.top.location = window.self.location;
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

reportWebVitals();
serviceWorker.unregister();
